<section>
  <ng-container *ngIf="isLoading; else loadedTemplate">
    <app-loading [onlyIcon]="true"></app-loading>
  </ng-container>
  <ng-template #loadedTemplate>
    <div class="risk-warning">
      <h2 class="risk-warning-title">{{ 'RISK_WARNINGS.TITLE' | i18nextEager }}</h2>
      <div class="risk-warning-resume">
        <div>
          <h3>{{ 'RISK_WARNINGS.STATE_MODIFICATION' | i18nextEager }}</h3>
          <h4>{{ avisosModificados }}</h4>
        </div>
        <div>
          <h3>{{ 'RISK_WARNINGS.PENDING_SECURE' | i18nextEager }}</h3>
          <h4>{{ avisosPendientes }}</h4>
        </div>
        <div>
          <h3>{{ 'RISK_WARNINGS.CANCELLATION' | i18nextEager }}</h3>
          <h4>{{ avisosCancelados }}</h4>
        </div>
      </div>
      <img class="risk-warning-goTo" src="/assets/icons/arrow.svg" alt="Arrow" (click)="handleNavigate()" />
      <app-table
        *ngIf="data"
        class="risk-warning-table"
        [data]="avisosList"
        [colsTable]="colsTable"
        (clickButton)="handleButton($event)"
      ></app-table>
    </div>
  </ng-template>
</section>
